import { useState } from 'react';
import apiClient from '../../../services/apiClientService';
import { useTenant } from '../../../contexts/TenantContext';
import useErrorHandler from '../../../hooks/useErrorHandler';
import { Routes } from '../../../routes/RouteConstants';

const useGetFreeSlotSchedules = () => {
  const { tenantId } = useTenant();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  // `providerId` absent is „Bárki”, or the only provider: a start is free while anyone offering the
  // supply is (docs/MULTI_PROVIDER.md).
  //
  // Resolves to the page, or `null` on failure. Publishes nothing: a background refresh pages
  // through this so it cannot interleave with the paging that runs through `data`.
  const fetchFreeSlotSchedules = async (startDate, supplyId, providerId) => {
    try {
      const response = await apiClient.get(`/v1/public/tenants/${tenantId}/daily-schedules/available`, {
        params: {
          startDate: startDate.format('YYYY-MM-DD'),
          supplyId,
          providerId,
        },
      });
      return response.data;
    } catch (error) {
      handleError(error, Routes.BOOKING);
      return null;
    }
  };

  const getFreeSlotSchedules = async (startDate, supplyId, providerId) => {
    setLoading(true);
    const page = await fetchFreeSlotSchedules(startDate, supplyId, providerId);
    if (page) setData(page);
    setLoading(false);
  };

  return { data, loading, getFreeSlotSchedules, fetchFreeSlotSchedules };
};

export default useGetFreeSlotSchedules;